import gql from 'graphql-tag'

export default gql`query ($id: Int!){
	project_expense(id: $id){
    id
    user_id
    expense_at
    destination
    description
    expense_type: expense_type_obj{
      id
      description
      vat_percentage
    }
    vat
    gross
    paid_at
    file_path
    project_id
    project{
      project_id
      name
    }
  }
}`